import { render, staticRenderFns } from "./HallsList.vue?vue&type=template&id=177aa6d4&lang=pug&"
import script from "./HallsList.vue?vue&type=script&lang=js&"
export * from "./HallsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports